import React from 'react';
import "./c87_slider_images_with_hover.scss";
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import Slider from "react-slick";
import {insertHtml} from "../../utils/dom";
import {Link} from "react-router-dom";

const SliderImagesWithHover = (props) => {
    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        dots: false,
        arrows: true
    };

    const elementRender = (index, title, image, desc, credits) => (
        <>
            <div key={index} className="slider-content">
                <div key={index} className="card-container">
                    <img src={image} alt={title}/>
                    <div className="text-background"/>
                    <div className="title">{title}</div>
                    <div className="description" {...insertHtml(desc)}/>
                    <div className="credits-label">{credits}</div>
                </div>
            </div>
        </>
    )

    return (<div id="sliderImagesWithHover" className="container-fluid">
        {(props.data.title_url) ? 
        <Link key={props.data.title_url} to={props.data.title_url}>
            <div className="title">{props.data.title}</div>
        </Link>  : <div className="title">{props.data.title}</div>}
        {props.data.subtitle && <div className="subtitle">{props.data.subtitle}</div>}
        <Slider {...settings}>
            {props.data.slider_cards && props.data.slider_cards.map((object, index) => (
                (object.link) ? 
                <Link key={index} to={object.link}>
                    {elementRender(index, object.title, object.image, object.description, object.credits_label)}
                </Link> : 
                    elementRender(index, object.title, object.image, object.description, object.credits_label)
            ))}
        </Slider>
    </div>)
};

class c87SliderImagesWithHover extends TemplateComponent {
    componentRender(data) {
        return (
            <SliderImagesWithHover data={data} lang={this.props.language}/>
        )
    }
}

export default c87SliderImagesWithHover;
